import React from 'react'
import {
  CButton,
} from '@coreui/react-pro'
import { styleButtonVars3 } from '../custom-styles/buttonStyles'
import { useResponsive } from 'src/helpers/get-responsive'

const AppCardHeader = ({
  headerTitle,
  headerButton,
  headerOtherButton,
  headerDownloadButton,
  handleCardHeaderButton,
  handleCardHeaderOtherButton,
  downloadLink,
  downloadName,
  disabled
}) => {
  const isDesktop = useResponsive();
  return (
    <div className="d-flex justify-content-between align-items-center">
      {headerTitle}
      <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
        {headerButton && (
          <CButton
            style={styleButtonVars3}
            onClick={() => handleCardHeaderButton()}
            disabled={disabled}
            className='fs-6 fs-md-4'
            size={isDesktop ? 'md' : 'sm'}
          >
            {headerButton}
          </CButton>
        )}
        {headerOtherButton && (
          <CButton
            style={styleButtonVars3}
            onClick={() => handleCardHeaderOtherButton()}
            disabled={disabled}
            className='fs-6 fs-md-4'
            size={isDesktop ? 'md' : 'sm'}
          >
            {headerOtherButton}
          </CButton>
        )}
        {headerDownloadButton && (
          <CButton
            target="__blank"
            style={styleButtonVars3}
            href={downloadLink}
            download={downloadName}
            disabled={disabled}
            className='fs-6 fs-md-4'
            size={isDesktop ? 'md' : 'sm'}
          >
            {headerDownloadButton}
          </CButton>
        )}
      </div>
    </div>
  )
}

export default AppCardHeader
